<template>
  <section class="h_15">
    <m-img class="h_15_1" src="@/v2/mobile/assets/image/h_15_1.png"></m-img>
    <div class="video1" v-ia>
      <m-video
        src="@/v2/auto/assets/video/37/2.mp4"
        poster="@/v2/mobile/assets/video/poster/v_15.webp"
        disablepictureinpicture
        class="border_container_light"
        muted
        x5-playsinline
        playsinline
        webkit-playsinline="true"
        autoplay
        ref="video1"
      ></m-video>
      <replay
        class="alive_replay"
        @click="() => replayVideo(this.$refs.video1)"
      />
    </div>
    <m-img class="h_15_2" src="@/v2/mobile/assets/image/h_15_2.png"></m-img>
    <div class="desc" v-html="controlList[activeIndex].desc"></div>
    <div class="video3" v-ia>
      <div class="alive_control">
        <div
          v-for="(i, index) in controlList"
          class="control_item"
          :class="index === activeIndex && 'control_item_active'"
          :key="i.url"
          @click="controlClick(index)"
        >
          {{ i.title }}
        </div>
      </div>
      <div class="border_container_light video_size f-select-center">
        <slider
          v-model="activeIndex"
          :controlBtn="false"
          :indicators="false"
          :autoplay="false"
          :touch="false"
          stopOnHover
          height="100%"
          width="100%"
        >
          <slider-item v-for="(i, index) in controlList" :key="i.title">
            <div>
              <m-video
                :ref="`video3_${index}`"
                disablepictureinpicture
                x5-playsinline
                playsinline
                webkit-playsinline="true"
                autoplay
                :src="i.url"
                preload="auto"
                :poster="i.poster"
                muted
              />
            </div>
          </slider-item>
        </slider>
      </div>
      <replay
        class="alive_replay"
        @click="() => replayVideo(this.$refs[`video3_${activeIndex}`][0])"
      />
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
import swipeMixin from '@/v2/mobile/mixins/swipeMixin.js'
export default {
  mixins: [swipeMixin],
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
      activeIndex: 0,
      videoAbortController: new AbortController(),
      controlList: [
        {
          title: '取色播放器',
          desc: `经典黑胶唱片，背景颜色随歌曲封面变化，<br/>画面更沉浸、通透`,
          url: require('@/v2/mobile/assets/video/15/3_0.mp4'),
          poster: require('@/v2/mobile/assets/video/15/3_0_poster.webp'),
        },
        {
          title: '星陨播放器',
          desc: `在星空中感受音乐的每一次律动，让歌词和流<br/>星与你同行`,
          url: require('@/v2/mobile/assets/video/15/3_1.mp4'),
          poster: require('@/v2/mobile/assets/video/15/3_1_poster.webp'),
        },
        {
          title: 'AI律动',
          desc: `AI 智能解析当前播放歌曲，随机生成沉浸式动<br/>态背景`,
          url: require('@/v2/mobile/assets/video/15/3_2.mp4'),
          poster: require('@/v2/mobile/assets/video/15/3_2_poster.webp'),
        },
      ],
    }
  },
  watch: {
    activeIndex(index) {
      this.nextVideoPlay(index)
    },
  },

  mounted() {
    this.$refs.video1 && videoPlayByVisibleAreaH5(this.$refs.video1)
    this.nextVideoPlay(this.activeIndex)
    this.videoPlayByVisible()
  },
  methods: {
    replayVideo,
    // 超出可视范围后暂停播放
    videoPlayByVisible() {
      this.controlList.forEach((_, index) => {
        const video = this.$refs[`video3_${index}`][0]
        video && videoPlayByVisibleAreaH5(video)
      })
    },
    controlClick(index) {
      // 先暂停当前视频
      if (this.$refs[`video3_${this.activeIndex}`]) {
        const currentVideo = this.$refs[`video3_${this.activeIndex}`][0]
        currentVideo.pause()
        currentVideo.currentTime = 0
      }

      this.activeIndex = index

      // 播放新视频
      if (this.$refs[`video3_${index}`]) {
        const nextVideo = this.$refs[`video3_${index}`][0]
        nextVideo.play()
      }
    },
    // 播放完成后自动跳转到下一个视频
    nextVideoPlay(index) {
      // 清除所有 ended 事件监听器
      this.videoAbortController.abort()
      this.videoAbortController = new AbortController()
      const video = this.$refs[`video3_${index}`][0]
      const nextVideoPlay = () => {
        this.activeIndex = (index + 1) % this.controlList.length
        this.controlClick(this.activeIndex)
        video.removeEventListener('ended', nextVideoPlay)
      }
      video.addEventListener('ended', nextVideoPlay, {
        signal: this.videoAbortController.signal,
      })
    },
  },
}
</script>
<style lang="less" scoped>
.h_15 {
  margin-top: -5px;
  position: relative;
  z-index: 85;
  background-color: #fff;
  padding: 0 24px 60px;
  .h_15_1 {
    width: 73%;
    margin-top: 125px;
  }
  .h_15_2 {
    width: 50%;
    margin-top: 125px;
  }
  .desc {
    font-size: clamp(16px, 1.5vw, 24px);
    color: #00000080;
    margin-top: 32px;
    line-height: 1.5;
    margin-bottom: 24px;
    font-weight: 400;
  }
  .video1,
  .video3 {
    width: 100%;
    position: relative;
  }
  .video1 {
    margin-top: 32px;
    width: 100%;
  }
  .video3 {
    margin-top: 32px;
  }
  .border_container_light {
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .video_size {
    overflow: hidden;
    aspect-ratio: 16/10;
    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
  }

  .alive_replay {
    margin-top: 22px;
    margin-left: 3px;
    color: #3b82fc;
  }
  .alive_control {
    border-radius: 2rem;
    background-color: #f4f4f5;
    height: max-content;
    display: flex;
    margin-bottom: 0.3rem;
    width: 100%;
    .control_item {
      cursor: pointer;
      margin: 0.15rem;
      font-size: 0.25rem;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: clamp(38px, 4.5vw, 44px);
      color: #00000080;
      text-align: center;
      flex: 1;
    }
    .control_item_active {
      color: black;
      font-weight: 600;
      background-color: white;
    }
  }
}
</style>
